import React, {useReducer} from "react";
import {
    Fab,
    Grid,
    Paper,
    withStyles,
    colors,
    Tooltip,
    Hidden,
    IconButton,
    ClickAwayListener,
} from "@material-ui/core";
import {withNotification} from "../contexts/NotificationContext";
import {IconCalendario, IconExpandir} from "./icons/MateraIcons";
import {withFb} from "../contexts/FbProvider";
import {withDialog} from "../contexts/DialogContext";
import classnames from 'classnames';
import reducer from '../utils/defaultReducer';

const styles = (theme) => ({
    player: {
        borderRadius: 0,
        flex: 1,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        justifyItems: 'center',
        boxShadow: 'none',
        backgroundColor: theme.palette.type === 'light' ? '#440099' : theme.palette.grey[800],
        transition: '0.3s all linear',
        [theme.breakpoints.up('sm')]: {
            maxHeight: 80,
            padding: '10px 0',
        },
        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column',
            position: 'absolute',
            top: 0,
            width: '100%',
            zIndex: 1,
            height: 240,
            "&.expanded": {
                transform: 'translateY(-40%)',
            }
        },
    },
    buttons: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flex: 1,
        [theme.breakpoints.down('xs')]: {
            margin: 0,
        },
    },
    playButton: {
        borderRadius: '50%',
        height: 90,
        width: 90,
        margin: '0 5px',
        backgroundColor: colors.blue[500],
        "& .fab-icon": {
            height: 60,
            width: 60,
            fill: 'white',
        },
        '&:hover': {
            backgroundColor: colors.blue[700],
        },
        [theme.breakpoints.up('sm')]: {
            height: 60,
            width: 60,
            "& .fab-icon": {
                height: 40,
                width: 40,
            },
        },
    },
    pauseButton: {
        borderRadius: '50%',
        height: 90,
        width: 90,
        margin: '0 5px',
        backgroundColor: colors.blue[500],
        color: 'white',
        "& .fab-icon": {
            height: 40,
            width: 40,
            fill: 'white',
        },
        '&:hover': {
            backgroundColor: colors.blue[700],
            color: 'white',
        },
        [theme.breakpoints.up('sm')]: {
            height: 60,
            width: 60,
            "& .fab-icon": {
                height: 24,
                width: 24,
            },
        },
    },
    stopButton: {
        borderRadius: '50%',
        color: theme.palette.getContrastText(colors.red[500]),
        backgroundColor: colors.orange[300],
        '&:hover': {
            backgroundColor: colors.orange[500],
        },
    },
    listButton: {
        borderRadius: '50%',
        // Fundo/texto agora vêm do Fab color="secondary" (verde da marca +
        // contrastText roxo escuro do theme.js). Antes forçava laranja aqui.
    },
    [theme.breakpoints.up('sm')]: {
        stopButton: {
            height: 40,
            width: 40
        },
        listButton: {
            height: 40,
            width: 40
        },
        "& .secundary-icon": {
            height: 25,
            width: 25
        }
    },
    leftBottomSide: {
        flex: 1,
        maxWidth: '50%',
        [theme.breakpoints.down('xs')]: {
            maxWidth: '100%',
            order: 1,
        },
    },
    rightBottomSide: {
        flex: 1,

    },
    expandButton: {
        position: 'absolute',
        top: 40,
        right: 20,
        color: 'white',
        transition: '.3s all linear',
        transform: 'rotate(0deg)',
        "&.expanded": {
            transform: 'rotate(180deg)',
        }
    }
});


function Player(props) {
    const initialState = {
        menu: false,
        expanded: false,
    };

    const [state, setState] = useReducer(reducer, initialState, () => initialState)

    const toggleExpanded = () => {
        setState(({expanded: !state.expanded}))
    }
    const expandLess = () => {
        setState({expanded: false})
    }

        const {classes} = props;
        return <ClickAwayListener
            onClickAway={expandLess}>
            <Paper className={classnames(classes.player, {'expanded': state.expanded})}>
                <Grid container justifyContent={'flex-start'} className={classes.leftBottomSide}>
                   
                </Grid>
                <Grid className={classes.buttons}>
                  
                    <Tooltip
                        title="Inconsistências"
                        placement={'top'}
                        enterDelay={300}>
                        <Fab color="secondary" className={classes.listButton}
                             aria-label="Menu"
                             onClick={() => props.setCalendar(state => !state)}>
                            <IconCalendario/>
                        </Fab>
                    </Tooltip>
                </Grid>
                <Hidden smDown>
                    <Grid className={classes.rightBottomSide}>
                    </Grid>
                </Hidden>
                <Hidden smUp>
                    <IconButton variant={'outline'} className={classnames(classes.expandButton, {'expanded': state.expanded})} onClick={toggleExpanded}>
                        <IconExpandir/>
                    </IconButton>
                </Hidden>
            </Paper>
        </ClickAwayListener>
}

export default withStyles(styles)(withNotification(withDialog(withFb(Player))));
